// Finbot API credentials + the loaded client list are reused across clients and across the
// journal / account-cards import modals, so they are persisted locally and prefilled instead of
// forcing the user to re-enter them each time.

export const FINBOT_SETTINGS_KEY = 'finbotImportSettings';
export const FINBOT_CLIENTS_KEY = 'finbotImportClients';

export const loadFinbotSettings = () => {
    try {
        const raw = localStorage.getItem(FINBOT_SETTINGS_KEY);
        const parsed = raw ? JSON.parse(raw) : {};
        return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
        return {};
    }
};

// Merge-persist so each modal only writes the fields it owns (e.g. the cards modal has no dates).
export const saveFinbotSettings = (patch) => {
    try {
        const current = loadFinbotSettings();
        localStorage.setItem(
            FINBOT_SETTINGS_KEY,
            JSON.stringify({ ...current, ...patch })
        );
    } catch {
        /* ignore storage errors (private mode, quota, etc.) */
    }
};

export const loadFinbotClientsCache = () => {
    try {
        const raw = localStorage.getItem(FINBOT_CLIENTS_KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
};

export const saveFinbotClientsCache = (clients) => {
    if (!Array.isArray(clients) || !clients.length) return;
    try {
        localStorage.setItem(FINBOT_CLIENTS_KEY, JSON.stringify(clients));
    } catch {
        /* ignore storage errors */
    }
};

// Find the Finbot client whose companyId matches the given accounting caseId.
export const matchFinbotClientByCaseId = (clients, caseId) => {
    if (!Array.isArray(clients) || !clients.length) return null;
    const normalizedCaseId = caseId != null ? String(caseId).trim() : '';
    if (!normalizedCaseId) return null;
    return clients.find((c) => String(c?.companyId ?? '').trim() === normalizedCaseId) || null;
};
